import { lazy } from 'react';

const TransformedMaterialConfig = {
	settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
		
	},
	routes: [
		{
			path: '/transformer/consult/material-transformed',
			component: lazy(() => import('./TransformedMaterialContainer'))
		}
	]
};

export default TransformedMaterialConfig;


